<template>
  <div class="pagina ativa" id="paginaLeads">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;border-bottom:2px solid #4a5c2f;padding-bottom:10px;">
      <div style="display:flex;align-items:center;gap:8px;font-size:22px;font-weight:bold;color:#4a5c2f;"><UserRound :size="22" /> Meus Leads</div>
      <button @click="carregarLeads" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 18px;font-size:13px;"><RefreshCw :size="13" /> Atualizar</button>
    </div>
    <div class="grid-cards" style="margin-bottom:20px;">
      <div class="card"><div class="card-label">Total Leads</div><div class="card-valor">{{ total }}</div></div>
      <div class="card"><div class="card-label">Novos</div><div class="card-valor" style="color:#e67e22;">{{ totalNovos }}</div></div>
      <div class="card"><div class="card-label">Contactados</div><div class="card-valor" style="color:#3498db;">{{ totalContactados }}</div></div>
      <div class="card"><div class="card-label">Fechados</div><div class="card-valor" style="color:#27ae60;">{{ totalFechados }}</div></div>
    </div>
    <div style="background:white;padding:15px 20px;border-radius:10px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:20px;display:flex;gap:15px;flex-wrap:wrap;align-items:flex-end;">
      <div v-if="ehAdmin">
        <label>Vendedor</label>
        <select v-model="fVendedor" style="width:180px;">
          <option value="">Todos</option>
          <option v-for="v in vendedoresDisponiveis" :key="v" :value="v">{{ v }}</option>
        </select>
      </div>
      <div>
        <label>Interesse</label>
        <select v-model="fInteresse" style="width:160px;">
          <option value="">Todos</option>
          <option>Automóvel</option>
          <option>Imóvel</option>
          <option>Pesados</option>
          <option>Moto / Serviço</option>
          <option>Cota Contemplada</option>
          <option>Dúvida geral</option>
        </select>
      </div>
      <div>
        <label>Status</label>
        <select v-model="fStatus" style="width:140px;">
          <option value="">Todos</option>
          <option value="Novo">Novo</option>
          <option value="Contactado">Contactado</option>
          <option value="Proposta Enviada">Proposta Enviada</option>
          <option value="Fechado">Fechado</option>
          <option value="Perdido">Perdido</option>
        </select>
      </div>
      <div>
        <label>Buscar</label>
        <input type="text" v-model="fBusca" placeholder="Nome ou WhatsApp..." style="width:200px;" />
      </div>
      <div><button @click="limparFiltros" style="margin:0;padding:10px 18px;font-size:13px;background:#888;">Limpar</button></div>
    </div>
    <div style="overflow-x:auto;">
      <table class="tabela-dash">
        <thead>
          <tr>
            <th>Data/Hora</th>
            <th v-if="ehAdmin">Vendedor</th>
            <th>Nome</th>
            <th>WhatsApp</th>
            <th>Interesse</th>
            <th>Valor</th>
            <th>Mensagem</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="carregando"><td :colspan="ehAdmin ? 9 : 8" style="padding:20px;text-align:center;color:#888;">Carregando...</td></tr>
          <tr v-else-if="!dados.length"><td :colspan="ehAdmin ? 9 : 8" style="padding:20px;text-align:center;color:#888;">Nenhum lead encontrado.</td></tr>
          <tr v-for="l in dados" :key="l.id">
            <td style="padding:8px;font-size:12px;">{{ l.data_hora }}</td>
            <td v-if="ehAdmin" style="padding:8px;">{{ l.vendedor }}</td>
            <td style="padding:8px;font-weight:bold;">{{ l.nome }}</td>
            <td style="padding:8px;">{{ l.whatsapp }}</td>
            <td style="padding:8px;">{{ l.interesse }}</td>
            <td style="padding:8px;font-size:12px;">{{ l.valor }}</td>
            <td style="padding:8px;font-size:11px;max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" :title="l.mensagem">{{ l.mensagem }}</td>
            <td style="padding:8px;"><span :style="{ background: corStatus(l.status), color: 'white', padding: '3px 8px', borderRadius: '10px', fontSize: '11px' }">{{ l.status }}</span></td>
            <td style="padding:8px;white-space:nowrap;">
              <select :disabled="atualizando[l.id]" @change="atualizarStatus(l, $event.target.value)" style="padding:4px 6px;font-size:11px;border:1px solid #ddd;border-radius:5px;margin:0;width:auto;">
                <option v-for="s in ['Novo','Contactado','Proposta Enviada','Fechado','Perdido']" :key="s" :value="s" :selected="l.status === s">{{ s }}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, getSession } from '../api'
import { UserRound, RefreshCw } from 'lucide-vue-next'

export default {
  components: { UserRound, RefreshCw },
  name: 'PaginaLeads',
  data() {
    return {
      leads: [],
      carregando: true,
      fVendedor: '',
      fInteresse: '',
      fStatus: '',
      fBusca: '',
      atualizando: {}
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    nomeUsuario() { return getSession().nome },
    vendedoresDisponiveis() {
      const vv = {}
      this.leads.forEach(l => { if (l.vendedor) vv[l.vendedor] = true })
      return Object.keys(vv).sort()
    },
    dados() {
      let d = this.leads.slice()
      if (this.fVendedor) d = d.filter(l => (l.vendedor || '').toLowerCase() === this.fVendedor.toLowerCase())
      if (this.fInteresse) d = d.filter(l => l.interesse === this.fInteresse)
      if (this.fStatus) d = d.filter(l => l.status === this.fStatus)
      if (this.fBusca) {
        const b = this.fBusca.toLowerCase()
        d = d.filter(l => (l.nome || '').toLowerCase().indexOf(b) > -1 || (l.whatsapp || '').indexOf(b) > -1)
      }
      return d
    },
    total() { return this.dados.length },
    totalNovos() { return this.dados.filter(l => l.status === 'Novo').length },
    totalContactados() { return this.dados.filter(l => l.status === 'Contactado' || l.status === 'Proposta Enviada').length },
    totalFechados() { return this.dados.filter(l => l.status === 'Fechado').length }
  },
  created() {
    this.carregarLeads()
  },
  methods: {
    corStatus(status) {
      return status === 'Novo' ? '#e67e22' : status === 'Fechado' ? '#27ae60' : status === 'Perdido' ? '#c0392b' : '#3498db'
    },
    async carregarLeads() {
      this.carregando = true
      const params = {}
      if (!this.ehAdmin) params.vendedor = this.nomeUsuario
      const r = await apiGet('leads/listar', params)
      if (r.sucesso) this.leads = r.leads
      this.carregando = false
    },
    limparFiltros() {
      this.fVendedor = ''
      this.fInteresse = ''
      this.fStatus = ''
      this.fBusca = ''
    },
    async atualizarStatus(lead, novoStatus) {
      this.$set ? this.$set(this.atualizando, lead.id, true) : (this.atualizando[lead.id] = true)
      const anterior = lead.status
      lead.status = novoStatus
      try {
        const r = await apiPost('leads/atualizar-status', { linha: lead.id, status: novoStatus })
        if (!r.sucesso) lead.status = anterior
      } catch (e) {
        lead.status = anterior
      } finally {
        this.atualizando[lead.id] = false
      }
    }
  }
}
</script>
